(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xl-sold-out-tag"] && !Shopify.designMode) return;
  try {
    (function () {
    var bind = function (tag) {
      if (tag.hasAttribute('data-xl-tag-bound')) return;
      tag.setAttribute('data-xl-tag-bound', '');
      var photo = tag.parentElement.querySelector('img:not(.xl-tag__layer)');
      var show = function () { tag.classList.add('is-shown'); };
      var tries = 0;
      var wait = function () {
        var anims = photo && photo.getAnimations ? photo.getAnimations() : [];
        if (anims.length) { Promise.all(anims.map(function (a) { return a.finished; })).then(show, show); return; }
        if (!photo || (photo.complete && parseFloat(getComputedStyle(photo).opacity) > 0.99)) { show(); return; }
        if (++tries > 60) { show(); return; }
        setTimeout(wait, 100);
      };
      wait();
    };
    var scan = function () { document.querySelectorAll('[data-xl-tag]').forEach(bind); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
